
import { networkDataArray } from '../../tools/networkData';
import { base, polygon, arbitrumNova, bsc, defineChain } from "thirdweb/chains";
import { FETCH_NETWORK_REQUEST, FETCH_NETWORK_SUCCESS, FETCH_NETWORK_FAILURE, UPDATE_NETWORK_INDEX } from '../actions/networkActions';

const initialState = {
  loading: false,
  networkIndex: 0,
  blockchain: networkDataArray[0], // Initial blockchain data
  error: null
};

const networkReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NETWORK_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_NETWORK_SUCCESS:
      return {
        ...state,
        loading: false,
        blockchain: action.payload,
        error: null
      };

    case FETCH_NETWORK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case UPDATE_NETWORK_INDEX:
      return {
        ...state,
        networkIndex: action.payload
      };

    default:
      return state;
  }
};

// Selectors
export const selectNetworkState = (state) => state.network;
export const selectBlockchain = (state) => state.network.blockchain;
export const selectNetworkIndex = (state) => state.network.networkIndex;
export const selectNetworkLoading = (state) => state.network.loading;
export const selectNetworkError = (state) => state.network.error;

const sonic = defineChain({ id: networkDataArray[0].chainId, rpc: networkDataArray[0].rpc});

export const chains = [sonic, bsc, base, polygon];

export const MAX = chains.length;

function getRandomCounter() {
  const numbers = Array.from({ length: MAX }, (_, i) => i); // [0, 1, 2, ..., 20]

  // Fisher-Yates shuffle
  for (let i = numbers.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1)); // Random index
      [numbers[i], numbers[j]] = [numbers[j], numbers[i]]; // Swap
  }

  return numbers[0]; // Return the first shuffled number
}

export const _counter = getRandomCounter();

export default networkReducer;
